import React from "react"
import { View, Text } from "react-native"

export default function Loading() {
    return (
        <View style={{ textAlign: "center", paddingVertical: 20 }}>
            <Text style={{ fontSize: 16 }}>Carregando...</Text>
        </View>
    )
}